"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flatknapp = exports.Fareknapp = exports.Hovedknapp = exports.Knapp = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
require("nav-frontend-knapper-style");
const cls = (props) => (0, classnames_1.default)("knapp", props.className, {
    "knapp--hoved": props.type === "hoved",
    "knapp--fare": props.type === "fare",
    "knapp--standard": props.type === "standard",
    "knapp--flat": props.type === "flat",
    "knapp--mini": props.mini,
    "knapp--disabled": props.disabled,
    "knapp--spinner": props.spinner,
    "knapp--kompakt": props.kompakt === true,
});
function skalVareDisabled(props) {
    if (props.autoDisableVedSpinner) {
        return props.disabled || props.spinner;
    }
    return props.disabled;
}
/**
 *  Knapp, Hovedknapp og Fareknapp arver alle fra KnappBase, og har da samme props.
 *  Unntaket er `type` som blir satt av de respektive underklassene.
 */
class KnappBase extends React.Component {
    render() {
        const _a = this.props, { children, className } = _a, props = __rest(_a, ["children", "className"]);
        const spinner = props.spinner ? React.createElement("span", { className: "knapp__spinner" }) : null;
        const ariaLabel = props.spinner ? { "aria-label": "Laster" } : {};
        const disabled = skalVareDisabled(props);
        const type = props.htmlType;
        const domProps = (0, nav_frontend_js_utils_1.omit)(Object.assign(Object.assign({}, props), { disabled, type }), "htmlType", "mini", "spinner", "autoDisableVedSpinner", "inaktivKlasseVedDisabled", "kompakt");
        return (React.createElement("button", Object.assign({ className: cls(this.props) }, domProps, ariaLabel),
            children,
            spinner));
    }
}
KnappBase.defaultProps = {
    type: "standard",
};
KnappBase.defaultProps = {
    autoDisableVedSpinner: false,
    inaktivKlasseVedDisabled: false,
    className: null,
    htmlType: "submit",
    mini: false,
    disabled: false,
    spinner: false,
    type: "standard",
    kompakt: false,
};
KnappBase.propTypes = {
    children: PT.node.isRequired,
    className: PT.string,
    type: PT.oneOf(["standard", "hoved", "fare", "flat"]),
    htmlType: PT.oneOf(["submit", "button", "reset"]),
    mini: PT.bool,
    disabled: PT.bool,
    spinner: PT.bool,
    autoDisableVedSpinner: PT.bool,
    inaktivKlasseVedDisabled: PT.bool,
    kompakt: PT.bool,
};
exports.default = KnappBase;
var knapp_1 = require("./knapp");
Object.defineProperty(exports, "Knapp", { enumerable: true, get: function () { return __importDefault(knapp_1).default; } });
var hovedknapp_1 = require("./hovedknapp");
Object.defineProperty(exports, "Hovedknapp", { enumerable: true, get: function () { return __importDefault(hovedknapp_1).default; } });
var fareknapp_1 = require("./fareknapp");
Object.defineProperty(exports, "Fareknapp", { enumerable: true, get: function () { return __importDefault(fareknapp_1).default; } });
var flatknapp_1 = require("./flatknapp");
Object.defineProperty(exports, "Flatknapp", { enumerable: true, get: function () { return __importDefault(flatknapp_1).default; } });
